import {handleAddToCartAndSyncApp} from "../../common/appShoppingCart";
import {useOverlay} from "../../common/step0Overlay";
import {fetchTimeout} from "../../common/fetch-timeout";
import {getCookieByName} from "../../common/cookie";

class AddtocartButton extends HTMLElement {
  static get observedAttributes() {
    return ["data-state"];
  }

  connectedCallback() {
    if (this.dataset.statex === "true") {
      return;
    }
    this.declareElements();
    this.renderButtons();
  }


  attributeChangedCallback(attributename, oldValue, newValue) {
    if (oldValue === newValue) {
      return;
    }
    if (attributename === "data-state") {
      this.changeButtonState(newValue);
    }
  }

  declareElements() {
    this.artikelnummer = this.dataset.artikelnummer;
    this.scriptTag = document.querySelector("script[name=addtocart]");
    this.isApp = (this.scriptTag?.getAttribute("is-app") === "true");
    this.openOverlay = (this.getAttribute("open-overlay") !== "false");
    this.price = this.getAttribute("price");
    this.productName = this.getAttribute("productname");
    this.category = this.getAttribute("category");
    this.itemList = this.closest('[component][impression="product"]');
    this.itemListId = this.itemList?.getAttribute("component");
    this.itemListName = this.itemList?.getAttribute("product-list") || this.itemListId || "";
  }

  renderButtons() {
    this.appendChild(this.createFormElement());
    if (this.isApp === true) {
      this.setSubmitListener();
    } else if (this.openOverlay !== true) {
      this.setClickListenerForPopover(this.querySelector(".warenkorb-button"), this.artikelnummer);
    } else {
      useOverlay(this, this.artikelnummer);
    }
  }

  createSnackbarElement(state, customMessage) {
    const snackbar = document.createElement("div");
    snackbar.className = state === "success" ? "element-snackbar-success" : "element-snackbar-warning";
    snackbar.setAttribute("data-animation", "slidein-bottom");
    snackbar.setAttribute("role", "status");
    snackbar.setAttribute("popover", "manual");

    const message = document.createElement("p");
    message.className = "element-text-standard-strong";
    message.textContent = customMessage ?? (state === "success" ? "Der Artikel wurde zum Warenkorb hinzugefügt" : "Der Artikel wurde nicht zum Warenkorb hinzugefügt");

    const closeButton = document.createElement("button");
    closeButton.setAttribute("cta", "close");
    closeButton.className = "element-button-quaternary-close";
    closeButton.textContent = "Popover schließen";

    const closeSnackbar = () => {
      snackbar.removeAttribute("animate");
      setTimeout(() => {
        snackbar.hidePopover();
        snackbar.remove();
      }, 1000);
    };

    closeButton.addEventListener("click", closeSnackbar);

    setTimeout(closeSnackbar, 5000);

    snackbar.appendChild(message);
    snackbar.appendChild(closeButton);

    if (state === "success") {
      const dlEvent = document.createElement("dl-event");
      dlEvent.setAttribute("name", "add_to_cart");
      const itemListContext = this.itemList ? "product-list" : "none";
      dlEvent.setAttribute("item-list-context", itemListContext);
      if (this.price) {
          dlEvent.setAttribute("totalvalue", this.price);
      }
      const dlProduct = document.createElement("dl-product");
      dlProduct.setAttribute("product-id", this.artikelnummer);
      if (this.itemListId) {
          dlProduct.setAttribute("item-list-id", this.itemListId);
      }
      if (this.itemListName) {
          dlProduct.setAttribute("item-list-name", this.itemListName);
      }
      if (this.price) {
          dlProduct.setAttribute("price", this.price);
      }
      if (this.productName) {
          dlProduct.setAttribute("name", this.productName);
      }
      if (this.category) {
          dlProduct.setAttribute("category", this.category);
      }
      dlEvent.appendChild(dlProduct);
      snackbar.appendChild(dlEvent);
    }

    return snackbar;
  }

  createFormElement() {
    const form = document.createElement("form");
    form.method = "post";
    form.action = "/warenkorb/hinzufuegen";

    const input = document.createElement("input");
    input.type = "hidden";
    input.name = "artikelnummer";
    input.value = this.artikelnummer;
    form.appendChild(input);

    const button = document.createElement("button");
    button.type = "submit";
    button.title = "Artikel hinzufügen";
    button.classList.add("element-button-primary-icon");
    button.classList.add("warenkorb-button");
    button.setAttribute("icon", "cart");
    button.setAttribute("basket", "add");
    button.setAttribute("product-id", this.artikelnummer);
    button.setAttribute("interaction", "direct-add-to-cart");
    button.setAttribute("aria-label", "Zum Warenkorb hinzufügen");

    const span = document.createElement("span");
    span.classList.add("element-icon-warenkorb-hinzufuegen");
    span.classList.add("icon-warenkorb-button");
    span.setAttribute("data-size","medium");
    span.setAttribute("aria-hidden", "true");
    button.appendChild(span);

    form.appendChild(button);
    return form;
  }

  setSubmitListener() {
    const form = this.querySelector("form");
    form.addEventListener("submit", (event) => handleAddToCartAndSyncApp(event, [ this.artikelnummer ]));
  }

  async setClickListenerForPopover(context, artikelnummer) {
    const artikelnummerString = artikelnummer.replace(/[^A0-9,]/g, '');
    context.addEventListener("click", (event) => {
      event.preventDefault();

      this.changeButtonState("loading");
      this.fetchContent(artikelnummerString);
    });
  }

  async presentSnackbar(state, customMessage) {
    this.snackbar = this.createSnackbarElement(state, customMessage);
    this.appendChild(this.snackbar);
    await this.customSleep(100);
    this.snackbar.showPopover();
    this.snackbar.setAttribute("animate", "");
  }

  async fetchContent(artikelnummer) {
    try {
      const config = {
        method: "POST",
        headers: {"x-csrf_global": getCookieByName("csrf_global")},
        body: new URLSearchParams({ headeronly: "true", artikelnummer: artikelnummer })
      };
      const response = await fetchTimeout("/warenkorb/overlay/hinzufuegen", config, true);
      if (response.status === 200) {
        this.changeButtonState("success");

        this.dispatchEvent(new CustomEvent("warenkorb.update", {bubbles: true}));
        await this.presentSnackbar("success");

      } else if (response.status === 400) {
        this.changeButtonState("success");

        // Auch im 400er Fall bekommen wir eine HTML Antwort vom Backend,
        // aus der wir an dieser Stelle nur die Fehlermeldung brauchen
        const errorMessage = await this.extractErrorMessage(response);

        console.error('Der Artikel wurde nicht hinzugefügt. ' + this.artikelnummer + '. Meldung vom Backend ist ' + (errorMessage ?? '<nicht extrahierbar>'));

        await this.presentSnackbar("warning", errorMessage);
      } else {
        // Hier laufen die ganzen technischen Fehler rein, z.B. 500er
        console.error("Der Artikel wurde nicht hinzugefügt. " + this.artikelnummer);

        await this.presentSnackbar("warning");
      }
    } catch (error) {
      console.log("FetchError! " + error)
    }
  }

  async extractErrorMessage(response) {
    try {
      const html = await response.text();
      const parsedFromString = new DOMParser().parseFromString(html, "text/html");
      const errorElement = parsedFromString.querySelector(".element-text-standard-negative");
      return errorElement?.textContent?.trim() || undefined;
    } catch (error) {
      console.error("Fehlerantwort konnte nicht geparst werden. " + error);
      return undefined;
    }
  }

  // Diese Funktion wird gebraucht, damit das animate-Attribut erst nach dem Bauen des Elements gesetzt wird.
  // Ansonsten wird das Element nicht animiert.
  customSleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms))
  }

  changeButtonState(newState) {
    const wkButton = this.querySelector(".warenkorb-button");
    const icon = this.querySelector(".icon-warenkorb-button");
    if (newState === "loading") {
      icon.classList.remove("element-icon-warenkorb-hinzufuegen");
      icon.classList.remove("element-icon-haekchen");
      icon.classList.add("element-icon-ladeindikator");
      wkButton.setAttribute("icon", "loading");
      this.resetButtonState(wkButton, icon, 5000);
    } else if (newState === "success") {
      icon.classList.remove("element-icon-warenkorb-hinzufuegen");
      icon.classList.remove("element-icon-ladeindikator");
      icon.classList.add("element-icon-haekchen");
      wkButton.setAttribute("icon", "checkmark");
      this.resetButtonState(wkButton, icon, 2000);
    }
  }

  resetButtonState(wkButton, icon, time) {
    setTimeout(() => {
      icon.classList.remove("element-icon-ladeindikator");
      icon.classList.remove("element-icon-haekchen");
      icon.classList.add("element-icon-warenkorb-hinzufuegen");
      wkButton.setAttribute("icon", "cart");
    }, time);
  }

}

if (!customElements.get("addtocart-button")) {
  customElements.define("addtocart-button", AddtocartButton);
}
